<template>
  <VLayout class="flex column" style="height: 100%">
    <VToolbar flat style="border-bottom: solid 1px #dddddd">
      <VToolbarTitle>
        <div>
          <span>Računi za pregled ({{ unreviewedCount }})</span>
        </div>
      </VToolbarTitle>
    </VToolbar>
    <v-text-field v-model="query" label="Iskanje" class="px-3" style="flex: 0" />
    <VList
      v-if="unProcessedInvoices.length > 0"
      class="pt-0 pb-0"
      style="height: calc(100% - 188px); overflow-y: auto; flex: 1 0 1"
      three-line
    >
      <VListTile
        v-for="invoice in unProcessedInvoices"
        :key="invoice.url"
        @click="setInvoice(invoice)"
        :class="{ active: activeInvoice && activeInvoice.url === invoice.url }"
      >
        <VListTileContent class="list-tile">
          <VListTileTitle v-text="invoice.file_name" />
          <VListTileSubTitle v-if="invoice.attachment" style="display: block; white-space: initial">
            <div style="display: flex; align-items: center; gap: 8px">
              <div>{{ invoice.attachment.received_mail.from_mail }}</div>
              <vChip
                v-if="invoice.attachment.received_mail.to_mail?.startsWith('irdoc')"
                dark
                class="ma-0"
                small
                color="primary"
              >
                {{ 'IR' }}
              </vChip>
            </div>
            <div>{{ invoice.attachment.received_mail.subject }}</div>
            <div>
              {{ invoice.created_at | moment('DD.MM.YYYY, HH:mm') }}
            </div>
          </VListTileSubTitle>
          <VListTileSubTitle v-else style="display: block; white-space: initial">
            <div>Poslano iz aplikacije Unija Scan</div>
          </VListTileSubTitle>
        </VListTileContent>
      </VListTile>
    </VList>
    <div class="invoice-pagination">
      <VBtn
        flat
        icon
        large
        color="primary"
        :disabled="!pagination.previous"
        @click="getUnprocessedInvoices(pagination.previous)"
      >
        <VIcon>navigate_before</VIcon>
      </VBtn>
      <VBtn
        flat
        color="primary"
        @click="getUnprocessedInvoices(`received-invoices/?status=WR&limit=8&query=${query}`)"
      >
        Osveži račune
      </VBtn>
      <VBtn
        flat
        icon
        large
        color="primary"
        :disabled="!pagination.next"
        @click="getUnprocessedInvoices(pagination.next)"
      >
        <VIcon>navigate_next</VIcon>
      </VBtn>
    </div>
  </VLayout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'InvoiceListTile',
  data() {
    return {
      query: '',
      timeout: null,
    };
  },
  computed: {
    ...mapGetters(['unProcessedInvoices', 'activeInvoice', 'unreviewedCount', 'pagination']),
  },
  watch: {
    query(value) {
      if (value.length >= 3) {
        this.debouncedFetchUnprocessedInvoices(
          `received-invoices/?status=WR&limit=10&query=${value}`
        );
      } else if (value.length === 0) {
        this.debouncedFetchUnprocessedInvoices('received-invoices/?status=WR&limit=10');
      }
    },
  },
  mounted() {
    this.getUnprocessedInvoices('received-invoices/?status=WR&limit=10');
  },
  destroyed() {
    this.$store.commit('setUnprocessedInvoices', []);
  },
  methods: {
    ...mapActions(['setActiveInvoice', 'getUnprocessedInvoices']),
    debouncedFetchUnprocessedInvoices(url) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getUnprocessedInvoices(url);
      }, 400);
    },
    setInvoice(invoice) {
      this.setActiveInvoice(invoice)
        .then()
        .catch((err) => {
          let error = '';
          if (err.response && err.response.data) {
            error = err.response.data.details;
          } else {
            error = err.message;
          }
          this.$store.dispatch('setSnackBarStateAction', {
            snackBar: true,
            color: 'info',
            text: `Napaka pri pridobivanju podatkov: \n ${error}`,
          });
          this.getUnprocessedInvoices('received-invoices/?status=WR&limit=8');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list__tile {
  height: auto !important;
  padding: 0 !important;
}
.list--scroll {
  overflow: scroll;
  padding: 0;
  flex: 1;
}
::-webkit-scrollbar {
  display: none;
}
.list-tile {
  border-radius: 5px;
  transition: background-color 0.2s ease;
}
::v-deep .v-list--three-line .v-list__tile {
  height: auto;
  min-height: 88px !important;
}
.active {
  background: rgba(0, 0, 0, 0.1);
}
.active:hover {
  background: rgba(0, 0, 0, 0.1);
}
</style>
